import { render, staticRenderFns } from "./QuestComponent.vue?vue&type=template&id=51cc4c95&"
import script from "./QuestComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports